import React, { useState , useContext, useEffect } from 'react'
import ReactTooltip from 'react-tooltip';
import Modal from './Modal'
import {ModalContext, UserContext, CategoryContext, TourContext} from "../../context"
import {updateUser} from "../../api/api"
import css from './Modal.module.scss'
import lCss from '../Layout/Layout.module.scss'

export default function ModalSettings({isOpen,closeModal}) {
	const {user, setUserCategories} = useContext(UserContext)
	const {toggleModal} = useContext(ModalContext)
	const {categories} = useContext(CategoryContext)
	const {tour} = useContext(TourContext)
	const [category, setCategory] =  useState(user.categories)

	const selectCategory = (item) => {
		const contain = category.some(e => e === item.list_id)
		const newFilter = contain ? category.filter(e => e !== item.list_id) : category.concat(item.list_id)

		setCategory(newFilter)
	}

	const onSubmit = async () => {
		const result = await updateUser({ids: category})
		if (result?.setPreferences?.code === "200") {
			setUserCategories(category)
			toggleModal({settings:false, settingsSuccess:true})
		} else {
			toggleModal({settings:false, error:true})
		}
	}

	useEffect(()=>{
		setTimeout(()=> {
			ReactTooltip.rebuild()
		},1);
		return () => {
			setCategory(user.categories)
		}
	},[isOpen])

	return (
		<Modal
			isOpen={isOpen}
			closeModal={closeModal}
			style={{
				content: {
					position:'static',
					display: 'inline-block',
					background: '#fff',
					overflow: 'auto',
					border: 'none',
					WebkitOverflowScrolling: 'touch',
					outline: 'none',
					boxShadow: '5px 15px 25px rgba(0, 0, 0, 0.5)',
					borderRadius: 'none',
					padding: '0',
					width:'550px',
					maxWidth: '100%',
					margin: '0 auto'
				},
				overlay: {
					position: 'fixed',
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: (tour.tour ? 'none' : 'rgba(0, 0, 0, 0.6)'),
					transform: (tour.tour ? 'translate(330px,50px)': 'none'),
					textAlign: 'center',
					zIndex: 99,
					overflow: 'auto',
					padding: '50px 0'
				}
			}}
		>
			<>
				<div className={css.title}>Избранные категории</div>
				<div className={css.categoryList}>
					{categories.map(item => {
						const active = category.some(e => e === item.list_id)

						return(
							<div
								key={item.list_id}
								className={css.category + ' ' + (active ? css.active : '')}
								data-tip={item.list_announce}
								data-place="bottom"
								data-class="tooltip"
								data-offset="{'top': 10, 'left': -100}"
								onClick={() => !tour.tour ? selectCategory(item) : null}
								>
								<i/>
								{item.list_title}
							</div>
						)
					})}
				</div>
				<input type="button" className={lCss.button + ' ' + lCss.w100} value="Cохранить" onClick={() => !tour.tour ? onSubmit() : null}/>
			</>
		</Modal>
	)
}